$(() => {
  function CardReaderDelegate() {}
  CardReaderDelegate.prototype = Object.create(window.StencilWebAPI.CardProcessingDelegate);

  /**
   * Private function to handle finding the cc input field from the griffin app. Set the
   * _cardInput to be the found input
   *
   * @private
   */
  CardReaderDelegate.prototype.getCardInput = function() {
    var inputs = $('#credit_card_input');
    if (inputs.length !== 1) {
      inputs = null;
    }

    return inputs;
  };

  /**
   * Private function to handle submitting the swipe to the register
   *
   * @private
   */
  CardReaderDelegate.prototype.submitSwipe = function() {
    window.merchantos.register.credit_card.submitSwipe('credit_card_input', 'credit_card_amount');
  };

  /**
   * Adds a payment terminal transaction to the sale.
   *
   * @param result  {window.StencilWebAPI.CardReader.TransactionResultType}  The result of the transaction
   * @param payment {object}  Transaction information used to create the payment.  Of the form:
   *						{
   *							saleID: "13",
   *							ccChargeID: "1",
   *							paymentTypeID: "3",
   *							salePaymentAmount: "20.00"
   *						}
   */
  CardReaderDelegate.prototype.paymentTerminalTransactionResult = function(result, payment) {
    switch (result) {
      case window.StencilWebAPI.CardReader.TransactionResultType.SUCCESSFUL_PAYMENT:
        if (payment) {
          window.merchantos.register.partial_payments
            .addPayment(payment.saleID, payment.salePaymentID || payment)
            .fail(function _onError(error) {
              console.error(error);
            });
        } else {
          console.error('Invalid payment data:', payment);
        }
        break;

      case window.StencilWebAPI.CardReader.TransactionResultType.NEED_MANUAL_CREDIT_CARD_UI:
        window.merchantos.register.credit_card.openManualEntry();
        break;

      case window.StencilWebAPI.CardReader.TransactionResultType.NO_PAYMENT_TERMINAL_CONFIGURED:
        window.merchantos.register.credit_card.open();
        break;

      default:
        console.error('Invalid transaction type:', result);
        break;
    }
  };

  /**
   * Removes a terminal transaction from the sale.  Used for transactions with a transaction
   * reference ID and no server-side support for voiding terminal transactions.
   *
   * @param result    {window.StencilWebAPI.CardReader.TransactionRefundByRefError}  The result of the refund by reference
   * @param referenceID {string}  The transaction reference ID
   * @param errorReason {window.StencilWebAPI.CardReader.TransactionRefundByRefError}    The reason for the error
   * @param errorMessage  {string}    The error message to dispaly when an error occurs during a refund
   */
  CardReaderDelegate.prototype.paymentTerminalRefundResult = function(
    result,
    referenceID,
    errorReason,
    errorMessage
  ) {
    switch (result) {
      case window.StencilWebAPI.CardReader.TransactionRefundByRefType.REFUND_SUCCESSFUL:
        if (referenceID) {
          window.merchantos.register.credit_card.removeEmvPayment(referenceID);
        } else {
          console.error('Invalid refund result.  No reference ID specified.');
        }
        break;

      case window.StencilWebAPI.CardReader.TransactionRefundByRefType.REFUND_NOT_COMPLETED:
        if (
          errorReason === window.StencilWebAPI.CardReader.TransactionRefundByRefError.REFUND_FAILED
        ) {
          if (errorMessage) {
            window.alertUser(errorMessage);
          } else {
            window.alertUser('An unknown error has occurred.');
          }
        } else if (
          errorReason ===
          window.StencilWebAPI.CardReader.TransactionRefundByRefError
            .REFUND_FAILED_MISSING_OR_MALFORMED_DATA
        ) {
          console.error('Invalid data supplied to the the native application.');
        }
        break;

      case window.StencilWebAPI.CardReader.TransactionRefundByRefType
        .NO_PAYMENT_TERMINAL_CONFIGURED:
        window.alertUser(
          'Voiding terminal payments requires that a terminal is configured in the application.'
        );
        break;

      default:
        console.error('Invalid refund transaction response:', result);
        break;
    }
  };
  window.CardReaderDelegate = CardReaderDelegate;
});
